const UUID_REGEX = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

/**
 * Validates that `id` is a well-formed UUID / GUID string.
 * Throws a RangeError if the value is present but not a valid UUID,
 * preventing attacker-controlled path-traversal or SSRF via URL injection.
 * Returns `id` unchanged when valid, or `undefined` when `id` is falsy.
 */
export function validateUuid(id: string | undefined | null): string | undefined {
    if (!id) return undefined;
    if (!UUID_REGEX.test(id)) {
        throw new RangeError(`Invalid identifier: expected a UUID but received "${id}"`);
    }
    return id;
}
